import { Component, OnInit } from "@angular/core";
import { SharedModule } from '../../share/shared.module';
import { DomSanitizer, Meta, SafeResourceUrl, Title } from '@angular/platform-browser';
import { AddExperience } from '../../services/AddExperience.service';
import { Router } from '@angular/router';
import * as globalConstant from '../../global_constant';
import { CanonicalService } from '../../services/canonical.service';
import { MainService } from '../../main.service';


@Component({
    selector: 'app-experiences-listing',
    standalone: true,
    imports: [
        SharedModule
    ],
    templateUrl: './experiences-listing.component.html',
    styleUrls: ['./experiences-listing.component.css']
})

export class ExperiencesListingComponents implements OnInit {
    locationList: any = [];
    divisionDataNested: any[] = [];
    divisionDataFlattened: any[] = [];
    siteUrl: String = globalConstant?.WEBSITE_URL;
    pageUrl: any = '';
    pageTitle: string = 'All Experiences';
    categoryList_for_experiece: any = '';
    category_image_url = '';

    constructor(
        private addexperience: AddExperience,
        private titleService: Title,
        private mainService: MainService,
        private canonicalService: CanonicalService,
        public router: Router,
        private metaService: Meta
    ) {
        let currenturl = this.router.url;
        let componentUrl = currenturl.startsWith('/') ? currenturl.slice(1) : currenturl;
        const canonicalUrl = this.normalizeUrl(this.siteUrl + componentUrl);
        this.canonicalService.setCanonical(canonicalUrl);
        this.pageUrl = canonicalUrl;
    }

    ngOnInit(): void {
        let category_slug_for_experience = { 'category_for': 'experience', 'type': 'higher-level-category' };
        this.mainService.get_categories(category_slug_for_experience).subscribe(res => {
            this.categoryList_for_experiece = res?.data;
            this.category_image_url = res?.image_url;

        });
        // this.addexperience.getAllLocationList().subscribe(res => {
        //     this.locationList = res.data;
        // });

        this.addMetaTags();
    }

    normalizeUrl(url: string): string {
        return url.endsWith('/') ? url.slice(0, -1) : url; // Remove trailing slash if present
    }

    addMetaTags() {
        this.titleService.setTitle('Explore All Experiences Categories | Spur Experiences');
        this.metaService.updateTag({ property: 'og:title', content: 'Explore All Experiences Categories | Spur Experiences' });

        // this.metaService.updateTag({ name: 'description', content: '' });
        // this.metaService.updateTag({ name: 'og:description', content: '' });

        // this.metaService.updateTag({ name: 'og:url', content: this.pageUrl });

        // this.metaService.updateTag({ name: 'og:image', content: '' });
    }
}